import { baseStoreCreator } from '@/utils/store';

export interface AccountFundingParamsPayload {
  planLevelFunding: boolean;
  isPreFundCalculated?: boolean;
}

export const DEFAULT_VALUES: AccountFundingParamsPayload = {
  planLevelFunding: false,
  isPreFundCalculated: false,
};

export const useStore = baseStoreCreator<AccountFundingParamsPayload>(DEFAULT_VALUES);

export default useStore;
